import moment from 'moment'
import qs from 'query-string'
import React, { useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useLocation } from 'react-router-dom'
import calendarAvatar from '../../../assets/icons/calendar-avatar.svg'
import clockAvatar from '../../../assets/icons/clock-avatar.svg'
import dolarAvatar from '../../../assets/icons/dolar-avatar.svg'
import monthAvatar from '../../../assets/icons/month-avatar.svg'
import petAvatar from '../../../assets/icons/pet-avatar.svg'
import Card from '../../../components/Card'
import Alert from '../../../components/Form/Alert'
import { SoonNews } from '../../../components/Modals'
import Ratings from '../../../components/Ratings'
import useGoTo from '../../../hooks/useGoTo'
import DateFilter from '../../../pages/Professionals/Dashboard/components/DateFilter'
import { formatDate } from '../../../utils/formatters'
import { NoInformationFound } from './components/Modals'
import { useDashboardReports } from './hooks/useDashboardReports'
import CardsContainer from '../../../components/CardsContainer'
import {
  Avatar,
  BlockFlex,
  DashboardContainer,
  InfoText,
  InfoTextContainer,
  Link,
  Subtitle,
  Text
} from './styles'

const Dashboard = () => {
  // a data em oldDate é referente ao período em que apenas a data do profissional principal esta disponível
  const oldDate = moment('2023-06-01')
  const { search } = useLocation()
  const { date } = qs.parse(search, { parseBooleans: true })
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const currentDate = moment()
  const paramDate = moment(date)
  const goToPage = useGoTo()
  const [selectedDate, setSelectedDate] = useState(paramDate ?? currentDate)
  const isSameMonthAndYear = selectedDate.month() === currentDate.month() && selectedDate.year() === currentDate.year()
  const report = useDashboardReports(professional.id, selectedDate, isSameMonthAndYear)
  const isLoading = !report
  const dateParam = `?date=${formatDate({ date: selectedDate, format: 'YYYY-MM-DD' })}&sameDate=${isSameMonthAndYear}`
  const isBeforeOldDate = moment(selectedDate).isBefore(oldDate)

  return (
    <SkeletonTheme baseColor="#D9D9D9">
      <DateFilter selectedDate={[selectedDate, setSelectedDate]} />
      <DashboardContainer>
        <InfoTextContainer>
          <InfoText>
            {isLoading
              ? <Skeleton count={2} />
              : <>
                Informações {isSameMonthAndYear ? 'deste' : 'do'} mês de <span>{formatDate({ date: selectedDate, format: 'MMMM', capitalizeMonth: true })}</span> até o dia {selectedDate.date()}
              </>
            }
          </InfoText>
        </InfoTextContainer>
        <CardsContainer>
          <Card loading={isLoading} skeletonHeight={215}>
            <Avatar src={calendarAvatar} alt="calendar avatar" />
            <BlockFlex cardInfo center>
              <Subtitle>{report?.finishedSchedulingsCount}</Subtitle>
              <Text>{report?.finishedSchedulingsCount === 1 ? 'atendimento finalizado' : 'atendimentos finalizados'}</Text>
              <Link marginTop='8px' onClick={
                !report?.anyScheduling
                  ? () => NoInformationFound(isSameMonthAndYear, 'scheduling')
                  : () => goToPage('/dashboard/scheduling-details', dateParam)
              }>Detalhes</Link>
            </BlockFlex>
          </Card>
          <Card loading={isLoading} skeletonHeight={215}>
            <Avatar src={dolarAvatar} alt="dolar avatar" />
            <BlockFlex cardInfo center>
              <Subtitle>{report?.monthTotalBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Subtitle>
              <Text>de faturamento bruto</Text>
              <Link marginTop='8px' onClick={
                !report?.finishedSchedulingsCount
                  ? () => NoInformationFound(isSameMonthAndYear, 'billing')
                  : () => goToPage('/dashboard/billing', dateParam)
              }>Detalhes</Link>
            </BlockFlex>
          </Card>
        </CardsContainer>
        <Card full loading={isLoading} skeletonHeight={130}>
          <BlockFlex cardInfo>
            {report?.mostScheduledService !== ''
              ? (
                <>
                  <Subtitle>{report?.mostScheduledService}</Subtitle>
                  <Text>serviço que mais realizou.</Text>
                </>
              ) : (
                <>
                  <Subtitle>Sem serviços finalizados</Subtitle>
                  <Text>Não foi finalizado nenhum agendamento ou encaixe.</Text>
                </>
              )
            }
            <Link left marginTop='8px' onClick={
              !report?.finishedSchedulingsCount
                ? () => NoInformationFound(isSameMonthAndYear, 'services')
                : () => goToPage('/dashboard/services', dateParam)
            }>Detalhes</Link>
          </BlockFlex>
          <Avatar src={petAvatar} alt='pet avatar' />
        </Card>
        <Alert show={isBeforeOldDate} type='warning'>
          Nesta data selecionada, apenas as informações do <strong>profissional principal</strong> estão disponíveis.
        </Alert>
        <Alert show={!isBeforeOldDate}>
          Lembrando que essas informações são referentes ao <strong>profissional principal e substitutos</strong>
          {isSameMonthAndYear ? ', e podem ter alterações até o fechamento do mês.' : '.'}
        </Alert>
      </DashboardContainer>
      <DashboardContainer secondary>
        <Card full skeletonHeight={144}>
          <BlockFlex cardInfo>
            <Subtitle>Produtividade</Subtitle>
            <Text>Acompanhe seus dias e horários mais produtivos do mês.</Text>
          </BlockFlex>
          <Avatar src={clockAvatar} alt="pet avatar" />
          <Link left border color="#E67500" onClick={SoonNews}>Detalhes</Link>
        </Card>
        <Card full skeletonHeight={144}>
          <BlockFlex cardInfo>
            <Subtitle>Comparativo mensal</Subtitle>
            <Text>Escolha mês e ano, compare e acompanhe sua evolução.</Text>
          </BlockFlex>
          <Avatar src={monthAvatar} alt="pet avatar" />
          <Link left border color="#E67500" onClick={SoonNews}>Realizar comparativo</Link>
        </Card>
      </DashboardContainer>
      <DashboardContainer secondary>
        <Ratings />
      </DashboardContainer>
    </SkeletonTheme>
  )
}

export default Dashboard
